import React from 'react';
import s from './PaymentsReceived.scss';
import { Heading, Text, Box, Divider } from '@wix/design-system';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { dateFormat, localDate, currencyFormat } from '../../../core';
import { dateFormatter as getDateFormatter } from '@wix/crm-financial-formatters';
import get from 'lodash.get';
const KnownPaymentMethods = {
    cash: 'invoice.payment-type.cash',
    transfer: 'invoice.payment-type.transfer',
    check: 'invoice.payment-type.check',
};
const PaymentsReceivedComponent = ({ t, invoice, primarySiteLocale, }) => {
    const { currencyCode: currency, locale } = invoice;
    const payments = invoice?.payments?.payments;
    const dateFormatter = primarySiteLocale
        ? getDateFormatter(primarySiteLocale, false)
        : localDate(dateFormat({ locale: locale && locale.language }));
    const currencyFormatter = currencyFormat({
        locale: locale && locale.language,
        currency,
    });
    if (!payments || payments.length === 0) {
        return null;
    }
    return (React.createElement(Box, { direction: "vertical" },
        React.createElement(Box, { margin: "0 48px 30px" },
            React.createElement(Divider, null)),
        React.createElement("div", { className: s.paymentsReceived },
            React.createElement(Heading, { className: s.title, size: "large", dataHook: "payments-received" }, t('price-quote.view.payments-received', { count: payments.length })),
            React.createElement(React.Fragment, null, payments.map((payment) => {
                const amount = get(payment, ['amount', 'serializedValue'], 0);
                const typeText = payment.type && payment.type in KnownPaymentMethods
                    ? t(KnownPaymentMethods[payment.type])
                    : payment.type;
                return (React.createElement(Box, { direction: "vertical", gap: "6px", marginBottom: "36px" },
                    payment?.date && (React.createElement(Text, { size: "small", secondary: true }, dateFormatter(new Date(payment.date)))),
                    React.createElement(Box, { direction: "horizontal", gap: "24px", height: "100%" },
                        payment?.type && (React.createElement(React.Fragment, null,
                            React.createElement(Text, null, typeText),
                            React.createElement(Divider, { direction: "vertical" }))),
                        React.createElement(Text, null, currencyFormatter(amount)))));
            })))));
};
const PaymentsReceived = withTranslation(['invoice-view', 'locale-data'])(PaymentsReceivedComponent);
export { PaymentsReceived };
//# sourceMappingURL=PaymentsReceived.js.map